<div class="w-full bg-white border-box" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="union-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">Organisations syndicales</p>
            <p class="no-margin dark-gray text-sm">Représentants syndicaux participant à la négociation</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>
    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>

  <div *ngIf="isExpanded">
    <div class="p-30 flex flex-column gap-30">
      <div *ngFor="let union of unions; let i = index" class="p-10 bg-light-gray" style="border: solid 1px #F0F5FF;">
        <app-union-verification [(union)]="unions[i]" [index]="i"
          (deleteAtIndex)="unions.splice($event, 1)"></app-union-verification>
        <!-- (unionChange)="onUnionChange()" -->
      </div>
    </div>

  </div>
  <div class="flex content-between p-20">
    <button class="edit-button" (click)="onEdit()">
      <img src="assets/pen-icon.svg" alt="">Modifier
    </button>
    <button *ngIf="!isValidated" class="validate-button" (click)="onValidate()">
      <img src="assets/valid-white-icon.svg" alt=""> Valider
    </button>
    <button *ngIf="isValidated" class="validated-button">
      <img src="assets/valid-green-icon.svg" alt="">
    </button>
  </div>
</div>